const TabPanel = ({ activeTabIndex, index, children }) => {
  if (activeTabIndex === index) {
    return children;
  }

  return null;
};

export default TabPanel;
